module.exports = __webpack_public_path__ + "assets/divi.f9db506e.svg";